import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModuloEnum } from '../../../enums/modulo.enum';
import { Funcionalidade } from '../../../services/models/usuario-admin/funcionalidade.model';
import { UsuarioAdminLoginResponse } from '../../../services/responses/usuario-admin/usuario-admin-login.response';
import { RouterModule } from '@angular/router';
import { FuncionalidadeEnum } from '../../../enums/funcionalidade.enum';
import { CommonModule } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { AuthService } from '../../../services/apis/usuario-admin/auth.service';

@Component({
  selector: 'app-funcionalidades',
  imports: [RouterModule, CommonModule, MatButton],
  templateUrl: './funcionalidades.component.html',
  styleUrl: './funcionalidades.component.css',
})
export class FuncionalidadesComponent implements OnInit {
  constructor(public authService: AuthService) {}

  @Input() showActionFuncionalidade: boolean;
  @Output() showActionFuncionalidadeFalse = new EventEmitter<number>();

  @Input() moduloEnum: ModuloEnum;
  @Input() funcionalidadeEnum: FuncionalidadeEnum;

  public _listaFuncionalidade: Funcionalidade[];

  ngOnInit(): void {
    const usuarioLoginResponse: UsuarioAdminLoginResponse = this.authService.getUserInfos();
    this._listaFuncionalidade = usuarioLoginResponse.listaFuncionalidades.filter(
      c => c.idModulo === this.moduloEnum
    );
  }

  clickContainerOut(): void {
    this.showActionFuncionalidadeFalse.emit();
  }
}
